import React from 'react'
import { FormControlLabel, Checkbox as MUICheckbox } from '@material-ui/core'
import useStyles from './FormFieldsStyle'

export default function Checkbox({ field }) {
  const classes = useStyles()
  return (
    <FormControlLabel
      control={
        <MUICheckbox
          checked={field.checked}
          onChange={field.onChange}
          name={field.label}
          className={classes.checkbox}
        />
      }
      label={field.label}
      className={field.withMargin && classes.withMargin}
    />
  )
}
